import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const PageTitle = styled.div`
  margin: 1em;
  font-size: 3em;
  color: ${COLOR.OUTER_SPACE};
`;
